import styled from "styled-components";

export const Label = styled.label`
    font-size: 1rem;
    margin-bottom: 0.5rem;

    @media (min-width: 590px) {
        font-size: large;
    }
`;
